import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const install = createReducer(
  {
    token: '',
    voucher: '',
    loading: false,
    pending: true,
    used: false,
    success: false
  },
  {
    [ActionTypes.INSTALL_VOUCHER_RESET]: state => {
      return {
        ...state,
        token: '',
        voucher: '',
        loading: false,
        pending: true,
        used: false,
        success: false
      };
    },
    [ActionTypes.INSTALL_VOUCHER_VALIDATE_REQUEST]: state => {
      return { ...state, loading: true };
    },
    [ActionTypes.INSTALL_VOUCHER_VALIDATE_DONE]: state => {
      return { ...state, loading: false };
    },
    [ActionTypes.INSTALL_VOUCHER_VALIDATE_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        token: payload.token,
        voucher: payload.code,
        success: true,
        categories: payload.categories
      };
    },
    [ActionTypes.INSTALL_VOUCHER_VALIDATE_USED_VALIDATE_SUCCESS]: (state, { payload }) => {
      return { ...state, token: payload };
    },
    [ActionTypes.POST_JOB_SUCCESS]: (state, { payload }) => {
      return { ...state, token: payload };
    },
    [ActionTypes.INSTALL_VOUCHER_TOKEN_UPDATE]: (state, { payload }) => {
      return { ...state, token: payload };
    },
    [ActionTypes.INSTALL_VOUCHER_VALIDATE_USED]: (state, { payload }) => {
      return { ...state, pending: false, used: true, voucher: payload.code };
    }
  }
);

export default install;
